import requests from "./api/base-api";

const TicketService = {
    getMyTickets: ()=>requests.get('/ticket/v1/get-my-ticket-list-user'),
}
export default TicketService;